seedWebApp.controller('PriceConfigController', ['$scope', '$uibModal', 'PricesService', 'TranslationService', 'ToastService', 
    function ($scope, $uibModal, PricesService, TranslationService, ToastService) {
        $scope.translation = TranslationService.getActiveTranslation();
    
        $scope.loadConfigs = function () {
            PricesService.getPriceConfigs().then(function (response) {
                $scope.items = response.data;
                //console.log('Configs');
                //console.log($scope.items);
                //console.log(response);
                if ($scope.items.length) {
                    $scope.pricePercentage = $scope.items[0].PricePercentage;
                }
            });
        };


        $scope.loadConfigs();

        $scope.readjustPrices = function (perc) {
            $scope.loading = true;
            var toastID = ToastService.createToast('Reajustando preços', '', 0, 'wait');
            PricesService.readjustPrices(perc).then(
                function () {
                    $scope.loading = false;
                    ToastService.updateToast(toastID, $scope.translation.ActionSuccessfullySaved, '', 4000, 'success');
                    PricesService.resetCache();
                    $scope.loadConfigs();
                },
                function (error) {
                    $scope.loading = false;
                    //console.log('savePrice error: ');
                    //console.log(error.data);
                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, $scope.translation.ErrorSaving, '', 4000, 'error');
                }
            );
        };
    }]
);